enum StatusDisplayLocation {
	Title = "Title",
    SubTitle = "Subtitle",
	Grid = "Grid",
}

export default StatusDisplayLocation;